import React from 'react';
import Typography from '../../../components/Typography';

const EmptyList:React.FC<{loading:boolean, total:number}> =({loading, total})=> {
    return <>{(!loading && total === 0) && <Typography variant="subtitle" textAlign='center'>No Records found.</Typography>}</>
}

export default EmptyList;